import React from "react";
import { useTranslation } from "react-i18next";
import {
  deriveTicketSoldStats,
  deriveTicketSoldTotals,
  rowExcludingGuestlistTicketStats,
} from "./ticketSoldStats";

function TicketSoldCell({
  row,
  totals,
  emptyLabel,
  soldOnly = false,
  excludeGuestlist = false,
}) {
  const { t } = useTranslation();
  const stats = totals
    ? deriveTicketSoldTotals(totals, { excludeGuestlist })
    : deriveTicketSoldStats(
        excludeGuestlist ? rowExcludingGuestlistTicketStats(row) : row
      );
  const { sold, total, pct, barLevel, soldToday } = stats;

  if (sold == null && total == null) {
    return (
      <span className="text-muted small">
        {emptyLabel ?? t("CLUB_SALES_VALUE_EMPTY")}
      </span>
    );
  }

  const soldDisplay = sold != null ? sold : "—";
  const totalDisplay = total != null ? total : "—";

  if (soldOnly) {
    return (
      <div className="club-sales-ticket-sold-cell">
        <div className="club-sales-ticket-sold-top">
          <div className="club-sales-ticket-sold-ratio">
            <span className="club-sales-ticket-sold-num">{soldDisplay}</span>
          </div>
          {soldToday != null && soldToday > 0 ? (
            <div className="club-sales-ticket-sold-today">
              <span className="club-sales-ticket-sold-today-text">
                {t("CLUB_SALES_TICKETS_SOLD_TODAY", { count: soldToday })}
              </span>
              <span className="club-sales-ticket-sold-today-icon" aria-hidden>
                ↑
              </span>
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  return (
    <div className="club-sales-ticket-sold-cell">
      <div className="club-sales-ticket-sold-top">
        <div className="club-sales-ticket-sold-ratio">
          <span className="club-sales-ticket-sold-num">{soldDisplay}</span>
          <span className="club-sales-ticket-sold-sep">/</span>
          <span className="club-sales-ticket-sold-total">{totalDisplay}</span>
        </div>
        {soldToday != null && soldToday > 0 ? (
          <div className="club-sales-ticket-sold-today">
            <span className="club-sales-ticket-sold-today-text">
              {t("CLUB_SALES_TICKETS_SOLD_TODAY", { count: soldToday })}
            </span>
            <span className="club-sales-ticket-sold-today-icon" aria-hidden>
              ↑
            </span>
          </div>
        ) : null}
      </div>
      {pct != null ? (
        <div className="club-sales-ticket-sold-bar-track">
          <div
            className={`club-sales-ticket-sold-bar-fill club-sales-ticket-sold-bar-fill--${barLevel}`}
            style={{ width: `${pct}%` }}
          />
        </div>
      ) : null}
    </div>
  );
}

export default TicketSoldCell;
